import React from "react";
import { useTranslation } from "react-i18next";

import css from "./Privacy.module.css";

export default function Privacy() {
  const { t } = useTranslation("footer");

  return (
    <section className={css.container}>
      <div className={css.content}>
        <h1 className={css.title}>{t("privacy.title")}</h1>

        <p className={css.update}>{t("privacy.update")}</p>

        <h2>{t("privacy.introTitle")}</h2>
        <p>{t("privacy.introText")}</p>

        <h2>{t("privacy.dataTitle")}</h2>
        <p>{t("privacy.dataText")}</p>

        <h3>{t("privacy.data2.1Title")}</h3>
        <p>{t("privacy.data2.1Text")}</p>

        <h3>{t("privacy.data2.2Title")}</h3>
        <p>{t("privacy.data2.2Text")}</p>

        <h3>{t("privacy.data2.3Title")}</h3>
        <p>{t("privacy.data2.3Text")}</p>

        <h2>{t("privacy.endingsTitle")}</h2>
        <p>{t("privacy.endingsText")}</p>

        <h2>{t("privacy.cookiesTitle")}</h2>
        <p>{t("privacy.cookiesText")}</p>

        <h2>{t("privacy.shareTitle")}</h2>
        <ul>
          <li>{t("privacy.shareText")}</li>
        </ul>

        <h2>{t("privacy.rightsTitle")}</h2>
        <p>{t("privacy.rightsText")}</p>

        <h2>{t("privacy.storeTitle")}</h2>
        <p>{t("privacy.storeText")}</p>

        <h2>{t("privacy.internationalTitle")}</h2>
        <p>{t("privacy.internationalText")}</p>

        <h2>{t("privacy.updatesTitle")}</h2>
        <p>{t("privacy.updatesText")}</p>

        <h2>{t("privacy.contactTitle")}</h2>
        <p>
          {t("privacy.contactText1")}
          <br />
          {t("privacy.contactText2")}
          <br />
          {t("privacy.contactText3")}
        </p>
      </div>
    </section>
  );
}
